module.exports = __webpack_public_path__ + "img/blue1.c0452141.svg";